import React from "react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { GripVertical, MoreVertical, Pencil, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type Tag from "@/model/interface/Tag";

interface TagRowProps {
  tag: Tag;
  onEdit: () => void;
  onDelete: () => void;
  onToggleActive: () => void;
  onDragStart: (e: React.DragEvent, id: string) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent, id: string) => void;
}

const TagRow: React.FC<TagRowProps> = ({ tag, onEdit, onDelete, onToggleActive, onDragStart, onDragOver, onDrop }) => {
  return (
    <div
      className="flex items-center gap-3 py-3 px-1"
      draggable
      onDragStart={(e) => onDragStart(e, tag.id)}
      onDragOver={onDragOver}
      onDrop={(e) => onDrop(e, tag.id)}
    >
      <GripVertical className="h-4 w-4 text-muted-foreground/40 shrink-0 cursor-grab active:cursor-grabbing" />
      <span className="h-4 w-4 rounded-full shrink-0" style={{ backgroundColor: tag.color }} />
      <div className="flex-1 min-w-0">
        <span className="text-sm font-medium">{tag.name}</span>
        {tag.description && <p className="text-xs text-muted-foreground truncate">{tag.description}</p>}
      </div>
      <Switch checked={tag.isActive} onCheckedChange={onToggleActive} className="shrink-0" />
      <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={onEdit}>
        <Pencil className="h-3.5 w-3.5" />
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" title="Options">
            <MoreVertical className="h-3.5 w-3.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem className="text-destructive" onClick={onDelete}>
            <Trash2 className="mr-2 h-4 w-4" />
            Delete tag
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default TagRow;
